import { Box, Button, Paper, Typography } from '@mui/material'
import React from 'react'

import aliveLogo from '../assets/alivelogo.png'
import { useNavigate } from 'react-router-dom'


const Logout = () => {


    const navigate = useNavigate()

    return (
        <Box height="100%" display="flex" alignItems="center" justifyContent="center">
            <Box height="100%" sx={{ background: "url('/imgs/bg-pattern1.png')", zIndex: "0" }} width="100%" display="flex" position="fixed" top="0" left="0" right="0" bottom="0" flexWrap="wrap" overflow="hidden">
            </Box>
            <Paper sx={{ position: "relative", zIndex: 2, maxWidth: "300px", width: "90%" }}>
                <Box padding="20px" alignItems="center" display="flex" flexDirection="column" gap="10px">
                    <img width="100px" src={aliveLogo} alt="Alive Logo" />
                    <Typography variant="h6">You are logged out</Typography>
                    <Button variant="outlined" onClick={() => navigate( 'https://rad-centaur-476dbd.netlify.app/' )} sx={{ textTransform: "capitalize" }}>Back to ERP</Button>
                </Box>
            </Paper>
        </Box>
    )
}

export default Logout
